import {
  Component, AfterViewInit, Input, Output, EventEmitter, OnChanges, SimpleChanges,
  ElementRef
} from '@angular/core';
import { DatePipe } from '@angular/common';


import { VenueDetailsOffer } from 'app/venues/venue-details/venue-details.model';
import { StatusChange } from '../contants/change-action-status';
import { convertToUTCDate } from 'app/venues/venue-details/date-helper-venue';


@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.less']
})
export class SliderComponent implements AfterViewInit, OnChanges {
  initialStartValue: number;
  initialPendingValue: number;
  initialLabel: string;
  initialLoad = true;
  initialValue: number;
  levelText = 'Level'

  @Input() id: string;
  @Input() startValue: number;
  @Input() pendingValue: number;
  @Input() displayArrow: string;
  @Input() pendingOfferRateTime: Date;
  @Input() notLive: boolean;
  @Input() offerLabel: string;
  @Input() utcOffset: number;

  @Input() status: string;
  @Input() isNew: boolean;

  @Input() initialStatus: string;

  @Input() offer: VenueDetailsOffer;
  @Input() oldOffer: VenueDetailsOffer;

  label: string;

  dirty: boolean;

  currentValueHidden: boolean;
  sliderElement: ElementRef;

  customSlider;

  constructor(sliderElement: ElementRef) {
    this.sliderElement = sliderElement;

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['displayArrow']) {
      this.displayArrow = changes['displayArrow'].currentValue;
    }

  }

  setHandlerValues(value) {
    switch (value) {
      case 25:
        return '0%';
      case 30:
        return '33,33%';
      case 40:
        return '66,66%';
      case 50:
        return '100%';
    }
  }

  getValueFromPercent(value) {
    switch (value) {
      case '0%':
        return 25;
      case '33,33%':
        return 30;
      case '33%':
        return 30;
      case '66,66%':
        return 40;
      case '66%':
        return 40;
      case '100%':
        return 50;
    }
  }

  ngAfterViewInit() {
    this.initialPendingValue = this.pendingValue;
    this.initialStartValue = this.startValue;

    this.customSlider = <HTMLElement>document.getElementById(this.id);

    if (this.customSlider.noUiSlider) {
      this.customSlider.noUiSlider.destroy();

      this.label = '';

      const arrowPointer = <HTMLElement>document.querySelectorAll('.slider-wrapper.' + this.id + ' .arrow-pointer')[0];
      arrowPointer.classList.remove('left');
      arrowPointer.classList.remove('right');
    }

    noUiSlider.create(this.customSlider, {
      range: {
        'min': [25],
        '33,33%': [30],
        '66,66%': [40],
        'max': [50]
      },
      pips: {
        mode: 'values',
        values: [25, 30, 40, 50],
        density: 50
      },
      format: {
        to: function (value) {
          return value + '%';
        },
        from: function (value) {
          return value;
        }
      },
      tooltips: true,
      behaviour: 'none',
      snap: true,
      start: [this.startValue]
    });

    setTimeout(() => {
      this.updatePercentageLine();

      const draggable = document.querySelectorAll('#' + this.id + ' .noUi-origin')[0];
      const newParent = document.getElementById(this.id);
      newParent.insertBefore(draggable, newParent.childNodes[0]);
      if (this.pendingValue && !this.notLive) {
        this.customSlider.noUiSlider.set(this.pendingValue);
        this.positionArrow(this.setHandlerValues(this.startValue), this.setHandlerValues(this.pendingValue));
        this.setLabel(this.setHandlerValues(this.startValue));
      }
    });

  }

  updatePercentageLine() {
    const slider = this.sliderElement;

    const draggable = <HTMLElement>document.querySelectorAll('#' + this.id + ' .noUi-origin')[0];
    const distanceFromLeft = draggable.style.left;
    const percentageLine = <HTMLElement>document.querySelectorAll('.slider-wrapper.' + this.id + ' .percentage-line')[0];
    const currentValue = <HTMLElement>document.querySelectorAll('.slider-wrapper.' + this.id + ' .current-value')[0];

    percentageLine.style.width = distanceFromLeft;
    currentValue.style.left = (draggable.offsetLeft - 11) + 'px';
    currentValue.innerHTML = this.customSlider.noUiSlider.get();

    this.setCurrentValuePosistion(slider);

    this.customSlider.noUiSlider.on('change', (values) => {

      setTimeout(() => {

        this.setCurrentValuePosistion(slider);

        const newValue = <HTMLElement>document.querySelectorAll('#' + this.id + ' .noUi-origin')[0];
        const newValueLeft = newValue.style.left;
        this.positionArrow(newValueLeft, 0);
        this.dirty = true;
        this.setLabel(newValueLeft);
      });

    });
  }

  setCurrentValuePositionEvent() {
    this.setCurrentValuePosistion(this.sliderElement);
  }

  setCurrentValuePosistion(slider) {

    const current = slider.nativeElement.querySelectorAll('.current-value')[0];
    const tooltip = slider.nativeElement.querySelectorAll('.noUi-tooltip')[0];

    if (this.initialLoad && this.initialPendingValue) {
      current.innerText = this.initialStartValue.toString() + '%';
      this.currentValueHidden = false;
    } else {
      if (tooltip.innerText === current.innerText) {
        this.currentValueHidden = true;
      } else {
        this.currentValueHidden = false;
      }
    }

    let parent = null;
    let leftScale = 0;

    if (current.innerText === '25%') {
      parent = slider.nativeElement.querySelectorAll('.slider-wrapper')[0].getBoundingClientRect();
      leftScale = slider.nativeElement.querySelectorAll('.noUi-marker')[0].getBoundingClientRect().left;
      current.style.left = (parent.left - leftScale - 11).toString() + 'px';
    } else if (current.innerText === '30%') {
      parent = slider.nativeElement.querySelectorAll('.slider-wrapper')[0].getBoundingClientRect();
      leftScale = slider.nativeElement.querySelectorAll('.noUi-marker')[1].getBoundingClientRect().left;
      current.style.left = (parent.left + (parent.width - (parent.width * 0.333333333)) - leftScale - 15).toString() + 'px';
    } else if (current.innerText === '40%') {
      parent = slider.nativeElement.querySelectorAll('.slider-wrapper')[0].getBoundingClientRect();
      leftScale = slider.nativeElement.querySelectorAll('.noUi-marker')[2].getBoundingClientRect().left;
      current.style.left = (parent.left + parent.width + parent.width - (leftScale + (parent.width * 0.666666666)) - 17).toString() + 'px';
    } else {
      parent = slider.nativeElement.querySelectorAll('.slider-wrapper')[0].getBoundingClientRect();
      leftScale = slider.nativeElement.querySelectorAll('.noUi-marker')[3].getBoundingClientRect().left;
      current.style.left = (parent.left + parent.width + parent.width - leftScale - 11).toString() + 'px';
    }
  }


  positionArrow(newValue, pendingValue) {
    const oldValue = <HTMLElement>document.querySelectorAll('.slider-wrapper.' + this.id + ' .percentage-line')[0];
    const oldValueWidth = oldValue.style.width;
    const arrowPointer = <HTMLElement>document.querySelectorAll('.slider-wrapper.' + this.id + ' .arrow-pointer')[0];

    if (pendingValue) {
      arrowPointer.style.left = (parseInt(newValue, 10) + parseInt(pendingValue, 10)) / 2 + '%';
      if (parseInt(pendingValue, 10) > parseInt(newValue, 10)) {
        arrowPointer.classList.remove('left');
        arrowPointer.classList.add('right');

      } else {

        if (this.initialLoad && this.oldOffer.pendingOfferRateTime && this.oldOffer.pendingOfferRate < this.oldOffer.offerRate) {
          arrowPointer.classList.add('left');
          return;
        }

        arrowPointer.classList.remove('left');
        arrowPointer.classList.remove('right');

      }
    } else {
      arrowPointer.style.left = (parseInt(newValue, 10) + parseInt(oldValueWidth, 10)) / 2 + '%';

      if (parseInt(newValue, 10) > parseInt(oldValueWidth, 10)) {
        arrowPointer.classList.remove('left');
        arrowPointer.classList.add('right');


      } else if (parseInt(newValue, 10) < parseInt(oldValueWidth, 10)) {
        arrowPointer.classList.remove('right');
        arrowPointer.classList.add('left');

      } else {
        arrowPointer.classList.remove('left');
        arrowPointer.classList.remove('right');

      }

    }

  }

  setLabel(value: string) {
    this.offer.offerRate = this.getValueFromPercent(value);

    this.label = '';

    let date = null;
    if (this.oldOffer.pendingOfferRateTime) {

      date = convertToUTCDate(this.oldOffer.pendingOfferRateTime);
    }

    if ((this.oldOffer.pendingOfferRate && ((this.offer.offerRate < this.oldOffer.offerRate && this.oldOffer.pendingOfferRate < this.oldOffer.offerRate) || (this.offer.offerRate > this.oldOffer.offerRate && this.oldOffer.pendingOfferRate > this.oldOffer.offerRate))) || (this.oldOffer.pendingOfferRate && this.initialLoad)) {
      this.label = (this.status !== 'NotLive' && !this.isNew)
        ? (this.oldOffer.offerRate < this.offer.pendingOfferRate || this.oldOffer.offerRate < this.offer.offerRate
          ? `${this.levelText} ${StatusChange.WillIncreaseFrom}` + new DatePipe('en-US').transform(this.oldOffer.pendingOfferRateTime, 'shortTime')
          : `${this.levelText} ${StatusChange.WillDecreaseFrom}` + new DatePipe('en-GB').transform(date, 'EEEE d'))

        : '';

    } else {
      this.label = (this.status !== 'NotLive' && !this.isNew)
        ? (this.oldOffer.offerRate < this.offer.offerRate ? `${this.levelText} ${StatusChange.WillIncreaseIn1Hr}` : (this.oldOffer.offerRate === this.offer.offerRate ? (date ? `${this.levelText} ${StatusChange.WillRemainAt}` + this.offer.offerRate + '%' : '') : `${this.levelText} ${StatusChange.WillDecreaseFrom}` + this.getDateLabel(this.offer)))
        : '';
    }

    if (this.label.endsWith('1') && !this.label.endsWith(' 11')) this.label += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (this.label.endsWith('2') && !this.label.endsWith(' 12')) this.label += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (this.label.endsWith('3') && !this.label.endsWith(' 13')) this.label += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (this.label.endsWith('1') || this.label.endsWith('2') || this.label.endsWith('3') || this.label.endsWith('4') || this.label.endsWith('5') || this.label.endsWith('6')
      || this.label.endsWith('7') || this.label.endsWith('8') || this.label.endsWith('9')
      || this.label.endsWith('0')) this.label += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');


    if (!this.initialLoad && this.initialPendingValue === this.offer.pendingOfferRate && this.initialStartValue === this.offer.offerRate && !this.dirty) {
      this.label = this.initialLabel;
    } else {
      if (this.label === `${this.levelText} ${StatusChange.WillRemainAt} ` + this.offer.offerRate + '%') {
        this.offer.pendingOfferRate = this.offer.offerRate;
      }
    }


    if (this.initialLoad) {
      this.initialLabel = this.label;
    }


    this.initialLoad = false;
  }

  getDateLabel(offer: VenueDetailsOffer) {
    let addDays = 0;
    let day = 0;

    let date = new Date();
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    date.setHours(date.getHours() + this.utcOffset);

    const today = date.getDay();

    switch (offer.day) {
      case 'Monday': {
        day = 1;
        break;
      }
      case 'Tuesday': {
        day = 2;
        break;
      }
      case 'Wednesday': {
        day = 3;
        break;
      }
      case 'Thursday': {
        day = 4;
        break;
      }
      case 'Friday': {
        day = 5;
        break;
      }
      case 'Saturday': {
        day = 6;
        break;
      }
      case 'Sunday': {
        day = 0;
        break;
      }

      default:
        break;
    }

    if (day < today) {
      addDays = 7 - (today - day);
    } else {
      addDays = day - today;
    }

    date.setDate(date.getDate() + addDays + 1);

    let resultLabel = new DatePipe('en-GB').transform(date, 'EEEE d');

    if (resultLabel.endsWith('1') && !resultLabel.endsWith(' 11')) resultLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('2') && !resultLabel.endsWith(' 12')) resultLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('3') && !resultLabel.endsWith(' 13')) resultLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('1') || resultLabel.endsWith('2') || resultLabel.endsWith('3') || resultLabel.endsWith('4') || resultLabel.endsWith('5') || resultLabel.endsWith('6')
      || resultLabel.endsWith('7') || resultLabel.endsWith('8') || resultLabel.endsWith('9')
      || resultLabel.endsWith('0')) resultLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

    return resultLabel;
  }


}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/slider/slider.component.ts